import { call, put, takeLatest } from "redux-saga/effects";
import { callDealsPostLoginGetApi } from "../Context/dealsPostLoginApi";
import {
  onGetDealsPostLogin,
  onGetDealsPostLoginError,
  onGetDealsPostLoginSuccess,
} from "../Store/Slices/dealsDataSlice";

function* GetDealsPostLogin({ payload }) {
  try {
    const response = yield call(callDealsPostLoginGetApi, payload);
    if (response.responseCode === "200") {
      yield put(
        onGetDealsPostLoginSuccess({
          data: response.response,
          message: response.responseMessage,
          status_code: response.responseCode,
        })
      );
    } else {
      yield put(
        onGetDealsPostLoginError({
          data: response.response,
          message: response.response?.message,
          status_code: response.responseCode,
        })
      );
    }
  } catch (error) {
    const message = error.response || "Something went wrong";
    yield put(
      onGetDealsPostLoginError({ data: [], message, status_code: 400 })
    );
  }
}

export default function* dealsPostLoginSaga() {
  yield takeLatest(onGetDealsPostLogin.type, GetDealsPostLogin);
}


